import React, { Component } from 'react'
import { Card, Container, Row, Col, Button, Form, Alert, Tabs, Tab, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { trackPromise } from 'react-promise-tracker';
import ButtonLoader from '../../components/ButtonLoader';
import { Link } from 'react-router-dom';
import api from '../../api';
import userAvatar from "../../assets/images/iconfinder_user.png";
import { AuthContext } from '../../contexts/auth';
import axios from 'axios';
import RichGooglePlacesAutoComplete from "../../autocomplete/RichGooglePlacesAutoComplete";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from "react-places-autocomplete";

export default class Index extends Component {
    static contextType = AuthContext;
    state = {
        firstName: "",
        lastName: "",
        email: "",
        cellNumber: "",
        // address: "",
        city: "",
        // area: "",
        gender: "",
        profileImage: "",
        tabKey: "profile-info",
        pointsTranferFail: false,
        pointsTranferSuccess: false,
        profilePic: "",
        selectPic: false,
        isLoading: false,
        latitude: "",
        longitude: "",
        editAddress: "",
        sendIsLoading: false,
        userType: ''
    }

    validSchema = Yup.object().shape({
        email: Yup.string().email(),
        // password: Yup.string(),
        // conPassword: Yup.string().oneOf([Yup.ref("password"), null], "Passwords must match"),
        cellNumber: Yup.string().max(11, 'Phone must contain 11 numbers').min(11, 'Phone must contain 11 numbers'),
        // city: Yup.string().matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
        city: Yup.string(),
        // area: Yup.string().matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
        // area: Yup.string().matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
        // area: Yup.string(),
    });

    validTransferPointsSchema = Yup.object().shape({
        cellNumber: Yup.string().required('required').max(10, 'Phone must contain 11 numbers').min(10, 'Phone must contain 11 numbers'),
        amount: Yup.number().required('required').min(1),
    });
    setProfile = async () => {
        try {
            const res = await api.get("/users/user");
            const { firstName, lastName, email, cellNumber, address, city, area, gender, profileImage, userType } = res.data.data.user
            console.log(firstName, lastName, email, cellNumber, address, city, area, gender, profileImage, userType)
            // history.push("/")
            this.setState({ firstName, lastName, email, cellNumber, address, city, area, gender, userType });
            if (profileImage) {
                this.context.setIsProfileImg(true);
                this.context.setProfile({ firstName, lastName, email, cellNumber, address, city, area, gender, profileImage: profileImage });
            }
            console.log(res.data.data);
        }
        catch (err) {
            // setAlert2(true);
            console.log(err)
        }
    }


    handleFormikFileChange = (e, formik) => {
        const file = e.target.files[0];
        formik.handleChange(e);
        console.log("file", file)
        this.setState({ profilePic: file, selectPic: true, })
    }
    onSubmitUpdateProfile = async (values, formProps) => {
        console.log("values", values)
        console.log("state", this.state.city)
        this.setState({ isLoading: true })
        try {
            if (this.state.selectPic) {
                const formData = new FormData();
                for (const key in values) {
                    if (Array.isArray(values[key])) {
                        formData.append(key, JSON.stringify(values[key]));
                    } else {
                        if (values[key] !== null)
                            formData.append(key, values[key])
                    }
                }
                formData.append('profileImage', this.state.profilePic);
                console.log("fORMdATA", formData);
                const res = await api.patch('/users/user', formData)
                console.log('res', res)
                this.setProfile();
                this.setState({ isLoading: false, tabKey: 'profile-info' })
            }
            else {
                const res = await api.patch("/users/user", values);
                console.log('res', res)
                this.setProfile();
                this.setState({ tabKey: 'profile-info', isLoading: false })
                console.log(values)
            }

        } catch (error) {
            console.log(error)
        }

    }

    onTransferPointsSubmit = async (values, resetForm) => {
        console.log("values", values)
        this.setState({ sendIsLoading: true })
        try {
            const res = await api.post("/points/user", values);
            console.log('res', res)
            resetForm({ values: "" });
            this.setState({ sendIsLoading: false, pointsTranferSuccess: true, pointsTranferFail: false })
        } catch (error) {
            this.setState({ sendIsLoading: false, pointsTranferFail: true, pointsTranferSuccess: false })
            console.log(error)
        }
    }
    setLocation = async () => {
        navigator.geolocation.getCurrentPosition(
            async (position) => {
                console.log(position.coords.latitude);
                console.log(position.coords.longitude);
                const res = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.coords.latitude},${position.coords.longitude}&sensor=false&key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}`);
                console.log("data: ", res.data.results[8].formatted_address);
                this.setState({ editAddress: res.data.results[0].formatted_address })
            },
            function (error) {
                console.error("Error Code = " + error.code + " - " + error.message);
            }
        );

    }
    componentDidMount() {
        this.setProfile();
    }
    render() {
        return (
            <>
                <section className="section-profile">
                    <div className="section-profile__profile-cards">
                        <Container>
                            {/* <h1 className="text-center mb-3 ml-5">{this.state.userType === 'BUYER_CORPORATE_COMPANIES' ? 'Corporate Buyer' : 'Individual Buyer'}</h1> */}
                            <Row>

                                <Col md="3">
                                    <Card className="section-profile__profile-menu p-4">
                                        <div className="mb-2 d-flex flex-column">
                                            <div className="section-profile__profile-menu__profile-img">
                                                {

                                                    this.context.isProfileImg ? (
                                                        <img
                                                            className="navigation__user-img"
                                                            src={this.context.profile.profileImage || this.state.profileImage}
                                                            alt="profile img"
                                                            style={{ width: "100%", height: "100%" }}
                                                        />) : (
                                                        <img
                                                            className="navigation__user-img"
                                                            src={userAvatar}
                                                            alt="profile img"
                                                            style={{ width: "100%", height: "100%" }}
                                                        />)
                                                }

                                            </div>
                                            {
                                                this.state.firstName ?
                                                    <h3 className="mt-3">{this.state.firstName} {this.state.lastName}</h3>
                                                    : "Enter Your Name"
                                            }
                                            <Link className="section-profile__profile-menu__Link" onClick={() => this.setState({ tabKey: 'profile-info' })}>My Profile</Link>
                                            <Link className="section-profile__profile-menu__Link" to="/wallet">My Wallet</Link>
                                            <Link className="section-profile__profile-menu__Link" onClick={() => this.setState({ tabKey: 'tranfer-points' })}>Tranfer Points</Link>
                                        </div>
                                    </Card>
                                </Col>

                                <Col md="9">
                                    <Card className="section-profile__profile-info p-4">

                                        <Tabs
                                            defaultActiveKey={this.state.tabKey}
                                            transition={false}
                                            id="noanim-tab-example"
                                            className="my-tabs"
                                        >
                                            <Tab eventKey="profile-info" title="" active={this.state.tabKey === "profile-info" ? true : false}>
                                                <Row>
                                                    <Col>
                                                        <div>
                                                            <h5>Name</h5>
                                                            {this.state.firstName != null ?
                                                                <p> {this.state.firstName} {this.state.lastName}</p>
                                                                : "Enter Your Name"
                                                            }
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div>
                                                            <h5>Email</h5>
                                                            <p>{this.state.email}</p>
                                                        </div>
                                                    </Col>
                                                    <Col>
                                                        <div>
                                                            <h5>Phone</h5>
                                                            {this.state.cellNumber ?
                                                                <p>{this.state.cellNumber}</p>
                                                                : "Enter Your Phone"
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row style={{ marginTop: "1.5rem" }}>
                                                    {/* <Col>
                                                        <div>
                                                            <h5>Adress</h5>
                                                            {this.state.address ?
                                                                <p>{this.state.address}</p>
                                                                : "Enter Your Address"
                                                            }
                                                        </div>
                                                    </Col> */}


                                                    <Col md='4'>
                                                        <div>
                                                            <h5>City</h5>
                                                            {this.state.city ?
                                                                <p>{this.state.city}</p>
                                                                : "Enter Your City"
                                                            }
                                                        </div>
                                                    </Col>
                                                    {/* <Col>
                                                        <div>
                                                            <h5>Area</h5>
                                                            {this.state.area ?
                                                                <p>{this.state.area}</p>
                                                                : "Enter Your Area"
                                                            }
                                                        </div>
                                                    </Col> */}
                                                    <Col md='3'>
                                                        <div>
                                                            <h5>Gender</h5>
                                                            {this.state.gender ?
                                                                <p>{this.state.gender}</p>
                                                                : "Enter Your Gender"
                                                            }
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* <Row style={{ marginTop: "2rem" }}>

                                                </Row> */}
                                                <div className="edit-profile mt-4">
                                                    <Button className="button-ghost" variant="outline-light" style={{ width: "27%" }} onClick={() => {
                                                        this.setState({ tabKey: 'profile-update' });
                                                        // this.setLocation();
                                                    }}> Edit Profile</Button>
                                                </div>

                                            </Tab>
                                            <Tab eventKey="profile-update" title="" active={this.state.tabKey === "profile-update" ? true : false}>
                                                <Formik
                                                    onSubmit={(values, formProps) => trackPromise(this.onSubmitUpdateProfile(values, formProps), 'contact-us')}
                                                    validationSchema={this.validSchema}
                                                    enableReinitialize
                                                    initialValues={{
                                                        firstName: this.state.firstName,
                                                        lastName: this.state.lastName,
                                                        email: this.state.email,
                                                        cellNumber: this.state.cellNumber,
                                                        // address: this.state.address ? this.state.address : this.state.editAddress,
                                                        city: this.state.city,
                                                        // area: this.state.area,
                                                        gender: this.state.gender,
                                                        // profilePic: this.state.profilePic
                                                    }}
                                                >
                                                    {(formik) => (
                                                        <Form onSubmit={formik.handleSubmit} id="profile-update-form">
                                                            <Form.Row>
                                                                <Form.Group controlId="firstName" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">First Name</Form.Label>
                                                                    <Form.Control
                                                                        className="p-3 rounded-0"
                                                                        type="text"
                                                                        name="firstName"
                                                                        placeholder="Enter Your firstName"
                                                                        value={formik.values.firstName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.firstName && !formik.errors.firstName}
                                                                        isInvalid={formik.touched.firstName && formik.errors.firstName}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.firstName}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>

                                                                <Form.Group controlId="lastName" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">Last Name</Form.Label>
                                                                    <Form.Control
                                                                        className="p-3 rounded-0"
                                                                        type="text"
                                                                        name="lastName"
                                                                        placeholder="Enter Your lastName"
                                                                        value={formik.values.lastName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.lastName && !formik.errors.lastName}
                                                                        isInvalid={formik.touched.lastName && formik.errors.lastName}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.lastName}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Form.Row>

                                                            <Form.Row>
                                                                <Form.Group controlId="cellNumber" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">Mobile Number</Form.Label>
                                                                    <Form.Control
                                                                        className="p-3 rounded-0"
                                                                        type="text"
                                                                        disabled={this.state.cellNumber ? true : false}
                                                                        name="cellNumber"
                                                                        placeholder="03xxxxxxxxx"
                                                                        value={formik.values.cellNumber}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                                                        isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.cellNumber}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                                <Form.Group controlId="email" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">Email</Form.Label>
                                                                    <Form.Control
                                                                        className="p-3 rounded-0"
                                                                        type="text"
                                                                        name="email"
                                                                        disabled={true}
                                                                        placeholder="Enter Email"
                                                                        value={formik.values.email}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.email && !formik.errors.email}
                                                                        isInvalid={formik.touched.email && formik.errors.email}
                                                                    />

                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.email}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>

                                                            </Form.Row>

                                                            <Form.Row>
                                                                {/* <Form.Group controlId="address" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">Address</Form.Label> */}
                                                                {/* <Form.Control
                                                                        className="p-3 rounded-0"
                                                                        type="text"
                                                                        name="address"
                                                                        placeholder="Enter Your address"
                                                                        value={formik.values.address}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.address && !formik.errors.address}
                                                                        isInvalid={formik.touched.address && formik.errors.address}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.address}
                                                                    </Form.Control.Feedback> */}
                                                                {/* <RichGooglePlacesAutoComplete defaultValue={formik.values.address} placeholder="  Address" onLocationSelect={({ description }) => {
                                                                        formik.setFieldValue('address', description);
                                                                        this.setState({ address: description })
                                                                    }} />
                                                                </Form.Group> */}
                                                                <Form.Group controlId="city" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">City</Form.Label>
                                                                    {/* <Form.Control
                                                                        className="p-3 rounded-0"
                                                                        type="text"
                                                                        name="city"
                                                                        placeholder="Enter Your city"
                                                                        value={formik.values.city}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                    // isValid={formik.touched.city && !formik.errors.city}
                                                                    // isInvalid={formik.touched.city && formik.errors.city}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid"> */}
                                                                    {/* {formik.errors.city} */}
                                                                    {/* </Form.Control.Feedback> */}
                                                                    <RichGooglePlacesAutoComplete defaultValue={formik.values.city} placeholder="  City" onLocationSelect={({ description }) => {
                                                                        formik.setFieldValue('city', description);
                                                                        this.setState({ city: description })
                                                                    }} />
                                                                </Form.Group>
                                                                <Form.Group controlId="gender" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">Gender</Form.Label>
                                                                    <Form.Control
                                                                        className="rounded-0"
                                                                        as="select"
                                                                        name="gender"
                                                                        // placeholder="Enter userType"
                                                                        value={formik.values.gender}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.gender && !formik.errors.gender}
                                                                        isInvalid={formik.touched.gender && formik.errors.gender}
                                                                        custom
                                                                    >
                                                                        <option value="" disabled>CHOOSE</option>
                                                                        <option value="male">Male</option>
                                                                        <option value="female">Female</option>
                                                                    </Form.Control>
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.gender}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Form.Row>
                                                            {/* <Form.Row> */}
                                                            {/* <Form.Group controlId="area" as={Col} hasValidation>
                                                                    <Form.Label className="form__label">Area</Form.Label> */}
                                                            {/* <Form.Control
                                                                        className="p-3 rounded-0"
                                                                        type="text"
                                                                        name="area"
                                                                        placeholder="Enter Your area"
                                                                        value={formik.values.area}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                    // isValid={formik.touched.area && !formik.errors.area}
                                                                    // isInvalid={formik.touched.area && formik.errors.area}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.area}
                                                                    </Form.Control.Feedback> */}
                                                            {/* <RichGooglePlacesAutoComplete defaultValue={formik.values.area} placeholder="  Area" onLocationSelect={({ description }) => {
                                                                        formik.setFieldValue('area', description);
                                                                        this.setState({ area: description })
                                                                    }} />
                                                                </Form.Group> */}

                                                            {/* </Form.Row> */}
                                                            <Form.Row>
                                                                <Form.Group as={Col} controlId="profilePic" hasValidation>
                                                                    <Form.Label className="form__label">Profile Pic</Form.Label>
                                                                    <Form.Control
                                                                        className="rounded-0"
                                                                        type="file"
                                                                        name="profilePic"
                                                                        value={formik.values.profilePic}
                                                                        onChange={e => this.handleFormikFileChange(e, formik)}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.profilePic && !formik.errors.profilePic}
                                                                        isInvalid={formik.touched.profilePic && formik.errors.profilePic}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.profilePic}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            </Form.Row>

                                                            <Button className="button-ghost" variant="outline-light" form='profile-update-form' type="submit">
                                                                {this.state.isLoading ? (
                                                                    <Spinner animation="border" size="sm" />
                                                                ) : ('')}
                                                                <span className={`${this.state.isLoading ? 'ml-2' : ''}`}>Update</span>
                                                            </Button>
                                                            <Button className="button-ghost ml-3" variant="outline-light" onClick={() => this.setState({ tabKey: 'profile-info' })}>
                                                                Back
                                                            </Button>
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </Tab>
                                            <Tab eventKey="tranfer-points" title="" active={this.state.tabKey === "tranfer-points" ? true : false}>
                                                {
                                                    this.state.pointsTranferFail ?
                                                        <Alert variant="danger" className="rounded text-align-center" dismissible onClose={() => this.setState({ pointsTranferFail: false })}>Invalid phone/You do not have enough Balance to perform this Transaction</Alert>
                                                        : ""
                                                }
                                                {
                                                    this.state.pointsTranferSuccess ?
                                                        <Alert variant="success" className="rounded text-align-center" dismissible onClose={() => this.setState({ pointsTranferSuccess: false })}>Successfully Transferd</Alert>
                                                        : ""
                                                }
                                                <Formik
                                                    validationSchema={this.validTransferPointsSchema}
                                                    onSubmit={(values, { resetForm }) => {
                                                        this.onTransferPointsSubmit(values, resetForm)
                                                        // resetForm({ values: "" })
                                                    }}
                                                    initialValues={{
                                                        cellNumber: "",
                                                        amount: "",
                                                    }}
                                                    enableReinitialize
                                                >
                                                    {(formik) => (
                                                        <Form className="sale-form mt-3" id="saleCreateForm" onSubmit={formik.handleSubmit} noValidate>
                                                            <Form.Row>

                                                                <Form.Group controlId="buyerPhone" as={Col} hasValidation>
                                                                    <Form.Label className="login-form__label">Phone</Form.Label>
                                                                    <Form.Control
                                                                        className="form-control"
                                                                        type="number"
                                                                        name="cellNumber"
                                                                        placeholder="Enter Phone"
                                                                        value={formik.values.cellNumber}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                                                        isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.cellNumber}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                                <Form.Group as={Col} hasValidation></Form.Group>
                                                            </Form.Row>
                                                            <Form.Row>
                                                                <Form.Group controlId="amount" as={Col} hasValidation>
                                                                    <Form.Label className="login-form__label">Amount</Form.Label>
                                                                    <Form.Control
                                                                        className="form-control"
                                                                        type="number"
                                                                        name="amount"
                                                                        placeholder="Enter Subka Faida Points"
                                                                        value={formik.values.amount}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched.amount && !formik.errors.amount}
                                                                        isInvalid={formik.touched.amount && formik.errors.amount}
                                                                    />
                                                                    <Form.Control.Feedback type="invalid">
                                                                        {formik.errors.amount}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                                <Form.Group as={Col} hasValidation></Form.Group>
                                                            </Form.Row>
                                                            <Button className="button-ghost" type='submit' form="saleCreateForm" variant="outline-light" style={{ width: "27%" }} >
                                                                {this.state.sendIsLoading ? (
                                                                    <Spinner animation="border" size="sm" />
                                                                ) : ('')}
                                                                <span className={`${this.state.sendIsLoading ? 'ml-2' : ''}`}>Send</span>       </Button>
                                                            {/* 
                                                            <Button className="d-flex align-items-center w-25 justify-content-center button-primary mt-3 mb-3" form="saleCreateForm" variant="primary" type="submit" block>
                                                                {this.state.sendIsLoading ? (
                                                                    <Spinner animation="border" size="sm" />
                                                                ) : ('')}
                                                                <span className={`${this.state.sendIsLoading ? 'ml-2' : ''}`}>Send</span>                                                            </Button> */}
                                                        </Form>
                                                    )}
                                                </Formik>
                                            </Tab>
                                        </Tabs>
                                    </Card>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section >
            </>
        )
    }
}
